module.exports = __webpack_public_path__ + "img/map-shopping-active.d320b154.png";